module.exports = __webpack_public_path__ + "static/media/guide1@3x.74c030fa.png";